<div
  class="trip-import-wrapper"
  [style.display]="showRangeSlider() ? 'none' : 'flex'">
  <div class="dv-headline-md">
    {{ 'General.SelectTripsForImport' | translate }}
  </div>
  <div class="trip-import-wrapper__grid">
    <app-trip-import-grid
      (tripSelectionChanged)="
        onTripSelectionChanged($event)
      "></app-trip-import-grid>
  </div>
  <div class="trip-import-wrapper__buttons">
    <dv-button (click)="cancel()">{{ 'General.Cancel' | translate }}</dv-button>
    <dv-button
      (click)="toggleTripSlider()"
      color="secondary"
      [disabled]="!selectedTripsCount()"
      >{{ 'General.Proceed' | translate }}</dv-button
    >
  </div>
</div>

@if (showRangeSlider()) {
  <div class="trip-import-slider">
    <app-range-slider
      class="trip-import-slider__range"
      [points]="tripPoints()"
      (rangeChange)="onSliderRangeChange($event)"></app-range-slider>
    <div class="trip-import-slider__buttons">
      <dv-button
        (click)="backToTripSelection()"
        [disabled]="importInProgress()"
        >{{ 'General.Back' | translate }}</dv-button
      >
      <dv-button
        (click)="save()"
        [disabled]="importInProgress()"
        color="secondary"
        >{{ 'TripsImport.Confirm' | translate }}</dv-button
      >
    </div>
  </div>
}

@if (importInProgress()) {
  <dv-progress-spinner
    [text]="'General.RouteGenerationInProgress' | translate"
    [displayProgressSpinner]="true"
    [isFullScreenSpinner]="true"></dv-progress-spinner>
}
